import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShoppingBag,
  QrCode,
  Monitor,
  Apple,
  Smartphone,
  ArrowRight,
} from 'lucide-react';

const pills = [
  { icon: ShoppingBag, label: 'Online Ordering', live: true },
  { icon: QrCode, label: 'QR Ordering', live: true },
  { icon: Apple, label: 'Apple Pay', live: true },
  { icon: Smartphone, label: 'Google Pay', live: true },
  { icon: Monitor, label: 'POS Lite · Coming Soon', live: false },
];

const BuiltForModernRestaurants = () => {
  return (
    <section
      className="relative bg-black py-20 lg:py-24 border-t border-white/[0.04]"
      data-testid="built-for-modern-restaurants"
    >
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-[11px] uppercase tracking-[0.28em] text-gold-400 font-semibold mb-4">
          Restaurant Solutions
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white">
          Built for modern restaurants.
        </h2>
        <p className="mt-4 max-w-xl mx-auto text-base text-white/60">
          Online ordering live today. Full restaurant POS in active development.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-3">
          {pills.map(({ icon: Icon, label, live }) => (
            <div
              key={label}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border transition-all duration-300 ${
                live
                  ? 'border-white/10 bg-white/[0.03] hover:border-gold-500/30 hover:bg-white/[0.05]'
                  : 'border-amber-500/25 bg-amber-500/[0.04] hover:border-amber-500/45'
              }`}
            >
              <Icon className={`w-3.5 h-3.5 ${live ? 'text-gold-300' : 'text-amber-300'}`} />
              <span className={`text-[13px] font-medium ${live ? 'text-white/80' : 'text-amber-200/90'}`}>
                {label}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <Link
            to="/for-restaurants"
            data-testid="explore-restaurant-solutions-btn"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-2xl bg-gradient-to-b from-amber-300 to-gold-500 hover:from-amber-200 hover:to-gold-400 text-black font-bold transition-all hover:shadow-[0_15px_40px_-15px_rgba(212,175,55,0.6)]"
          >
            Explore Restaurant Solutions
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BuiltForModernRestaurants;
